import { MODAL_PRICING } from '@components/App/Modal/constants'
import type { ID } from '@octopus-do/octopus-project-core'
import { DashboardActions } from '@store/reducers/dashboard/actions'
import { openModal } from '@storeOld/reducers/ui'
import { useDispatch } from 'react-redux'

export const useWorkspaceActions = (workspaceId: ID) => {
  const dispatch = useDispatch()
  const onAvatarRemove = () =>
    dispatch(DashboardActions.teams.removeAvatar({ workspaceId }))

  const onSetAvatar = (files: FileList | null) => {
    if (!files) {
      return
    }
    dispatch(DashboardActions.teams.updateAvatar({ workspaceId, files }))
  }

  const onPlanClick = () => dispatch(openModal(MODAL_PRICING))

  const onRename = (title: string) => {
    dispatch(DashboardActions.teams.rename({ title, workspaceId }))
  }

  return { onRename, onAvatarRemove, onSetAvatar, onPlanClick }
}
